"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/TranslationLabel.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _translation = require('shared/selectors/translation');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _TranslationIcon = require('./TranslationIcon'); var _TranslationIcon2 = _interopRequireDefault(_TranslationIcon);













/* One line under a bubble ("Translated from Vietnamese · See original") whose
 * link reveals the other text under it. Each viewer toggles it locally. */
const RevealLine = ({
  className, label, showLabel, hideLabel, hiddenText, hiddenLang, hasIcon = false, children,
}) => {
  const [isRevealed, setIsRevealed] = _react.useState.call(void 0, false)
  const onToggle = _react.useCallback.call(void 0, () => setIsRevealed(revealed => !revealed), [])

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'message-translation', className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
      , _react2.default.createElement('div', { className: "message-translation--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
        ,  hasIcon && _react2.default.createElement(_TranslationIcon2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 33}} ) 
        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 34}},  label )
        , _react2.default.createElement('span', { 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, "·")
        , _react2.default.createElement('button', {
          type: "button",
          className: "message-translation--toggle",
          'aria-expanded': isRevealed,
          onClick: onToggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}

          ,  isRevealed ? hideLabel : showLabel 
        )
      )
      ,  isRevealed && (_nullishCoalesce(children, () => ( (
        _react2.default.createElement('div', { className: "message-translation--revealed", lang: hiddenLang, dir: "auto", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
          ,  hiddenText 
        )
      ))))
    )
  )
}






/* Under a patient message: its translation's label, "Translation off · Show
 * translation" when translation is off but a translation was saved before
 * (the bubble shows the original; the saved English is one click away), or
 * "Translation unavailable" when it failed (the bubble shows the original). */
 const InboundTranslationLabel = ({ display, originalText }) => {
  if (!display) return null
  if (display.kind === 'failed') {
    return (
      _react2.default.createElement('div', { className: "message-translation message-translation--failed" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
        , _react2.default.createElement('div', { className: "message-translation--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
          , _react2.default.createElement(_TranslationIcon2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 69}} )
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, "Translation unavailable" )
        )
      )
    )
  }
  if (display.kind === 'saved') {
    return (
      _react2.default.createElement(RevealLine, {
        hasIcon: true,
        label: "Translation off" ,
        showLabel: "Show translation" ,
        hideLabel: "Hide translation" ,
        hiddenText: display.text,
        hiddenLang: "en", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
      )
    )
  }
  return (
    _react2.default.createElement(RevealLine, {
      hasIcon: true,
      label: `Translated from ${_translation.languageName.call(void 0, display.sourceLanguage)}`,
      showLabel: "See original" ,
      hideLabel: "Hide original" ,
      hiddenText: originalText,
      hiddenLang: display.sourceLanguage || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
    )
  )
}; exports.InboundTranslationLabel = InboundTranslationLabel












/* A household reply: "Sent in Spanish to Maria Lopez · as written to Leo
 * Lopez", each translated copy one click away under the patient's name, and
 * why a shared phone got the text as typed. */
const HouseholdDeliveredLabel = ({ display, className }) => {
  const hint = display.hint
    ? _react2.default.createElement('div', { className: "message-translation--line message-translation--hint" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}},  display.hint )
    : null
  if (display.copies.length === 0) {
    return (
      _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'message-translation', className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}
        , _react2.default.createElement('div', { className: "message-translation--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}, _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 120}},  display.label ))
        ,  hint 
      )
    )
  }
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(RevealLine, {
        className: className,
        label: display.label,
        showLabel: "Show sent text"  ,
        hideLabel: "Hide sent text"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}

        , _react2.default.createElement('ul', { className: "message-translation--revealed message-translation--copies" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}
          ,  display.copies.map(copy => (
            _react2.default.createElement('li', { key: copy.patientName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}
              , _react2.default.createElement('span', { className: "message-translation--copy-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 136}}
                ,  `${copy.patientName} (${_translation.languageName.call(void 0, copy.language)}):` 
              )
              ,  ' ' 
              , _react2.default.createElement('span', { lang: copy.language || undefined, dir: "auto", __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}},  copy.text )
            )
          ))
        )
      )
      ,  hint && _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'message-translation', className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}},  hint ) 
    )
  )
}

/* Under a staff message that went out in the patient's language: the bubble
 * keeps the staff member's English; this reveals what the patient got. A
 * message already in that language says it went out as written. In a
 * household it names who got which language. */
 const DeliveredLabel = ({ display, alignRight }) => {
  if (!display) return null
  if (display.kind === 'household') {
    return _react2.default.createElement(HouseholdDeliveredLabel, { display: display, className: alignRight ? 'message-translation--right' : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}} )
  }
  if (display.kind === 'as-written') {
    return (
      _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'message-translation', alignRight ? 'message-translation--right' : undefined), __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}
        , _react2.default.createElement('div', { className: "message-translation--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 163}},  `Sent as written (already ${_translation.languageName.call(void 0, display.language)})` )
        )
      )
    )
  }
  return (
    _react2.default.createElement(RevealLine, {
      className: alignRight ? 'message-translation--right' : undefined,
      label: `Sent in ${_translation.languageName.call(void 0, display.targetLanguage)}`,
      showLabel: "Show sent text"  ,
      hideLabel: "Hide sent text"  ,
      hiddenText: display.text,
      hiddenLang: display.targetLanguage || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}
    )
  )
}; exports.DeliveredLabel = DeliveredLabel
